import { ActionTypes } from "../action-type";

const initialState = {
        status:null,
        plan:null
}


export const subscriptionReducer = (state = initialState,action)=>{
    switch(action.type){
        case ActionTypes.SUBSCRIPTION_CHECK:
            return{...state,
                status:action.payload.status,
                plan:action.payload.plan
            }
        default:
            return state;
    }
}